module.exports = __webpack_public_path__ + "static/jumbotron2-5ad47aae12355d55c86bcb408d88ba08.jpg";